import {createStore, combineReducers, applyMiddleware} from 'redux';
import createHistory from 'history/createBrowserHistory';
import {routerReducer, routerMiddleware} from 'react-router-redux';
import allReducers from './reducers';
import thunk from 'redux-thunk';

const history = createHistory();

const middleware = routerMiddleware(history);

const store = createStore(
    combineReducers({
        ...allReducers,
        router: routerReducer,
    }),
    applyMiddleware(thunk, middleware)
);

export {store, history};

